import React from 'react';
import { Image } from '@adobe/react-spectrum';
import { getCategoryIcon } from '../../../utils/categoryIconUtils';

interface AllIconsPopupProps {
  allItems: Array<{ type: 'category' | 'product'; value: string }>;
  onError?: (event: any) => void;
  tooltipRef: React.RefObject<HTMLDivElement>;
}

export const AllIconsPopup: React.FC<AllIconsPopupProps> = ({
  allItems,
  onError,
  tooltipRef
}) => {
  return (
    <>
      <style>{`
        .all-icons-popup::-webkit-scrollbar {
          display: none;
        }
      `}</style>
      <div
        ref={tooltipRef}
        className="all-icons-popup"
        style={{
          position: 'absolute',
          top: '100%',
          left: '0',
          marginTop: '8px',
          display: 'flex',
          flexWrap: 'wrap',
          gap: '12px',
          maxWidth: '280px',
          maxHeight: '300px',
          overflowY: 'auto',
          padding: '12px',
          backgroundColor: '#fff',
          border: '1px solid #e0e0e0',
          borderRadius: '6px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          zIndex: 10000,
          scrollbarWidth: 'none', // Firefox
          msOverflowStyle: 'none' // IE and Edge
        }}
      >
        {allItems.map((item, index) => (
          <div
            key={`tooltip-${item.type}-${item.value}-${index}`}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '4px',
              minWidth: '60px'
            }}
          >
            <Image
              src={
                item.type === 'category'
                  ? getCategoryIcon([item.value], [])
                  : getCategoryIcon([item.value], [item.value])
              }
              alt={item.value}
              width="32px"
              height="32px"
              onError={onError}
            />
            <span
              style={{
                fontSize: '10px',
                color: '#666',
                textAlign: 'center',
                wordBreak: 'break-word'
              }}
            >
              {item.value}
            </span>
          </div>
        ))}
      </div>
    </>
  );
};
